/**
 * Maison Alira — Wishlist (localStorage, no app required)
 * Paste this file into: assets/wishlist.js
 * Then load it in theme.liquid, right before </body>:
 *   {{ 'wishlist.js' | asset_url | script_tag }}
 */

const Wishlist = {
  STORAGE_KEY: 'maison_alira_wishlist',

  getAll() {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  },

  save(items) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(items));
    this.updateCount();
  },

  has(productId) {
    return this.getAll().some((item) => item.id === productId);
  },

  add(product) {
    const items = this.getAll();
    if (!items.some((item) => item.id === product.id)) {
      items.push(product);
      this.save(items);
    }
  },

  remove(productId) {
    const items = this.getAll().filter((item) => item.id !== productId);
    this.save(items);
  },

  toggle(product) {
    if (this.has(product.id)) {
      this.remove(product.id);
      return false; // now removed
    } else {
      this.add(product);
      return true; // now added
    }
  },

  clear() {
    this.save([]);
  },

  count() {
    return this.getAll().length;
  },

  updateCount() {
    const count = this.count();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  Wishlist.updateCount();

  // Wire up any heart buttons on the page (product cards, product page, etc.)
  // Expected markup: <button class="wishlist-toggle" data-product-id="{{ product.id }}"
  //                    data-product-title="{{ product.title | escape }}"
  //                    data-product-handle="{{ product.handle }}"
  //                    data-product-image="{{ product.featured_image | image_url: width: 400 }}"
  //                    data-product-price="{{ product.price | money }}"></button>
  document.querySelectorAll('.wishlist-toggle').forEach((btn) => {
    const productId = btn.dataset.productId;
    if (Wishlist.has(productId)) {
      btn.classList.add('is-active');
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const product = {
        id: productId,
        title: btn.dataset.productTitle,
        handle: btn.dataset.productHandle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        variantId: btn.dataset.variantId || null,
      };
      const added = Wishlist.toggle(product);
      btn.classList.toggle('is-active', added);
    });
  });
});
